import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  TextField,
  InlineStack,
  ColorPicker,
  Layout,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const HeaderText = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, HEADER_TEXT, COLOR, DEFAULT_TEXT_COLOR } = constant;

  return (
    <Layout.AnnotatedSection
      title={cms("section.headerTextColor.title")}
      description={cms("section.headerTextColor.description")}
    >
      <Card
        title={[
          cms("section.headerTextColor.title"),
          updatedAt && (
            <Text as="span" tone="subdued">
              <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
            </Text>
          ),
        ]}
        // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.headerTextColor.title"), "TODO: ") }]}
      >
        <Card.Section>
          <BlockStack gap="2">{cms("section.headerTextColor.subDescription")}</BlockStack>
          <br />
          <InlineStack align="space-between">
            <Box width="60%">
              <BlockStack>
                <TextField
                  label={cms("section.headerTextColor.label.hexCode")}
                  value={hex.headerTextHex}
                  onChange={(value) => handleChange(HEADER_TEXT, value, HEX)}
                  error={errorMessage && errorMessage.headerText}
                  labelAction={
                    hex.headerTextHex !== DEFAULT_TEXT_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(HEADER_TEXT, DEFAULT_TEXT_COLOR, HEX),
                    }
                  }
                />
                <br />
                <Text as="span" variant="bodySm">
                  <div
                    style={{
                      borderRadius:".5rem",
                      width:"max-content",
                      height: "28px",
                      background: hex.headerHex,
                      color: hex.headerTextHex,
                      textAlign: "center",
                      padding: "6px 12px",
                    }}
                  >
                    {cms("section.headerTextColor.label.sampleText")}
                  </div>
                </Text>
              </BlockStack>
            </Box>
            <ColorPicker onChange={(value) => handleChange(HEADER_TEXT, value, COLOR)} color={color.headerText} />
          </InlineStack>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  );
};

export default withFeature(withErrorBoundary(HeaderText), {
  feature: constant.STANDARD_BRANDING,
});
